import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bathroom-vent-fan-calculator',
  component: () => import('../../routes/BathroomVentFanCalculator.svelte'),
  card: {
    id: 'bathroom-vent-fan-calculator',
    title: 'Bathroom Vent Fan CFM',
    description:
      'Size any bath, kitchen, or laundry exhaust fan in CFM. HVI fixture-based sizing (50 CFM/toilet, 50/shower, 100/jetted tub) or ASHRAE 62.2 ACH-based sizing (8 ACH baths, 15 ACH kitchens) with duct loss compensation.',
    icon: 'air',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/bathroom-vent-fan-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Bathroom Vent Fan CFM Calculator – Size Exhaust Fan (HVI & ASHRAE 62.2)',
    description:
      'Free bathroom vent fan CFM calculator. Find the right exhaust fan size in CFM using HVI fixture-based sizing or ASHRAE 62.2 ACH-based sizing. Includes duct loss compensation, sones noise reference, and standard residential fan recommendations.',
  },
};

export default meta;
